import { render, staticRenderFns } from "./FormConsultation.vue?vue&type=template&id=fa5df444&"
import script from "./FormConsultation.vue?vue&type=script&lang=js&"
export * from "./FormConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports